import 'whatwg-fetch';
import {AuthService, auth} from '../services/auth';
import {config} from './config';

/**
 * - Automatically converts "/api*" requests to call the backend
 * - Automatically enhances requests to the api with the authorization token
 * - If we're working locally it also attempts to invoke the local server before calling the configured server.
 */
export async function DeereFetch(url, options = {}) {
    options.query = options.query || {};

    if (url.startsWith('/api')) {
        options.headers = options.headers || {};
        options.headers.Authorization = `Bearer ${auth.config.providers[0].idToken.raw}`;

        if (config.isDevelopmentEnvironment) {
            if (AuthService.overrideRole) {
                options.headers['X-Role-Override'] = AuthService.overrideRole;
            }

            if (localStorage.getItem('localhost') === 'true') {
                return await DeereFetch(url.replace('/api', 'http://localhost:8080'), options);
            }
        }

        return await DeereFetch(url.replace('/api', config.api), options);
    } else {
        const request = new URL(url);
        const entries = Object.entries(options.query).sort(([key], [otherKey]) => {
            return key.localeCompare(otherKey);
        });

        for (const [key, value] of entries) {
            if (Array.isArray(value)) {
                value.sort().forEach((v) => request.searchParams.append(key, v));
            } else if (value) {
                request.searchParams.append(key, value);
            }
        }

        const response = await window.fetch(request, options);

        const content = response.headers.get('Content-Type') && response.headers.get('Content-Type').includes('application/json') ? await response.json() : await response.text();

        return response.status >= 400 ? Promise.reject(content) : content;
    }
}

const cache = {};

export async function DeereCachedFetch(url, options = {}, rebuildCache) {
    const key = btoa(url) + btoa(JSON.stringify(options));

    if (rebuildCache) {
        delete cache[key];
    }

    if (!cache[key]) {
        options.cacheDuration = options.cacheDuration || 1000; // One second.

        cache[key] = DeereFetch(url, options).finally(() => {
            if (options.cacheDuration !== 'forever') {
                setTimeout(() => {
                    delete cache[key];
                }, options.cacheDuration);
            }
        });
    }

    return await cache[key];
}
